export const INVALID_CREDENTIALS = "Invalid Credentials.";
export const EMAIL_ALREADY_EXISTS = "Email already exists.";
export const FILE_ALREADY_EXISTS = "File already exists.";
export const OCN_ALREADY_EXISTS = "OCN already exists.";
export const OR_ALREADY_EXISTS = "OR already exists.";
export const MULTIMEDIA_MIME_TYPES = ".jpeg,.jpg,.png,.gif,.pdf,.docx,.doc";
export const MULTIMEDIA_PLACEHOLDER = "Supports: JPEG, PNG, GIF, DOCX, PDF";
export const IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const IMAGE_MIME_TYPES_PLACEHOLDER = "Supports: JPEG, PNG, GIF";
export const TOKEN_KEY = "token";
